import styled from 'styled-components';

const StepMLStyled = styled.div`
  .step-form-wrap {
    font-family: SourceHanSansCN;
    .text-input-style {
      width: 100%;
    }
    .MuiTypography-colorTextSecondary {
      color: #000000;
    }
    .MuiRadio-colorSecondary.Mui-checked {
      color: ${(props) => props.theme.palette.primary.main};
    }
    .input-error-style {
      color: #f44336;
      margin: 0;
      font-size: 0.75rem;
      margin-top: 3px;
      text-align: left;
      font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
      font-weight: 400;
      line-height: 1.66;
      margin-left: 14px;
      letter-spacing: 0.03333em;
    }
    .select-wrap-style {
      width: 100%;
    }
    .textField-area-wrap {
      height: auto;
      textarea {
        padding-top: 10px;
      }
    }
    .coupon-item-style {
      color: #000000;
    }
  }
`;
export default StepMLStyled;
